const subscirbe = Object.freeze({
    text: "Stay informed and never miss an update!",
});


export default subscirbe;